// removed by extract-text-webpack-plugin
module.exports = {"Amount":"Amount___2CuhE","label":"label___1DBw9","input":"input___3Q4qk","schemas":"schemas___4ciXI"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/Amount/styles.scss
// module id = 448
// module chunks = 0